var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconVideoCall = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.269,
    height: 8.179,
    viewBox: "0 0 12.269 8.179",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_videocam_24px",
    d: "M12.542,9.067V6.682A.684.684,0,0,0,11.861,6H3.682A.684.684,0,0,0,3,6.682V13.5a.684.684,0,0,0,.682.682h8.179a.684.684,0,0,0,.682-.682V11.112l2.726,2.726v-7.5Z",
    transform: "translate(-3 -6)",
    fill: "#ad8e56"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconVideoCall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-video-call.36f2a455227d898f7ef725dd9da694e9.svg";